document.addEventListener('DOMContentLoaded', () => {
    console.log("Start Contact Form");
    const form = document.getElementById('contactForm');
    const step1 = document.getElementById('step1');
    const step2 = document.getElementById('step2');
    const nextStepButton = document.getElementById('nextStep');
    const prevStepButton = document.getElementById('prevStep');
    const submitBtn = document.getElementById('submitBtn');
    const supportCategoryRadios = document.getElementsByName('supportCategory');
    const originSupport = document.getElementById('originSupport');
    const generalTechnical = document.getElementById('generalTechnical');
    const statusElement = document.getElementById('status');
    const countrySelect = document.getElementById('country');
    const messageTextarea = document.getElementById('message');
    const messageCounter = document.getElementById('message-counter');

    // Populate country dropdown
    const countries = [
        "United Kingdom", "United States", "Canada", "Australia", "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo, Democratic Republic of the", "Congo, Republic of the", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czechia", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, North", "Korea, South", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
    ];
    countries.forEach(country => {
        const option = document.createElement('option');
        option.value = country;
        option.textContent = country;
        countrySelect.appendChild(option);
    });

    // Character counter for message
    messageTextarea.addEventListener('input', () => {
        const count = messageTextarea.value.length;
        messageCounter.textContent = `${count} / 8000 characters`;
    });

    // Clear error messages on input
    countrySelect.addEventListener('change', () => {
        clearFieldError(countrySelect, 'country-error');
    });

    supportCategoryRadios.forEach(radio => {
        radio.addEventListener('change', () => {
            clearFieldError(radio, 'category-error');
            updateRequiredFields();
        });
    });

    // Next step button
    nextStepButton.addEventListener('click', () => {
        if (validateStep1()) {
            console.log("Proceed to step 2");
            step1.classList.add('hidden');
            step1.setAttribute('aria-hidden', 'true');
            step2.classList.remove('hidden');
            step2.removeAttribute('aria-hidden');
            updateRequiredFields();
            document.getElementById('firstName').focus();
            
            // Announce step change to screen readers
            announceToScreenReader('Step 2 of 2: Ticket Details');
        }
    });

    // Previous step button
    prevStepButton.addEventListener('click', () => {
        console.log("Return to step 1");
        step2.classList.add('hidden');
        step2.setAttribute('aria-hidden', 'true');
        step1.classList.remove('hidden');
        step1.removeAttribute('aria-hidden');
        countrySelect.focus();
        
        // Announce step change to screen readers
        announceToScreenReader('Step 1 of 2: Country and Support Category');
    });

    function validateStep1() {
        let isValid = true;
        const countryError = document.getElementById('country-error');
        const categoryError = document.getElementById('category-error');

        // Clear previous errors
        countryError.textContent = '';
        categoryError.textContent = '';
        countrySelect.removeAttribute('aria-invalid');

        // Validate country
        if (countrySelect.value === "") {
            countryError.textContent = "Please select your country.";
            countrySelect.setAttribute('aria-invalid', 'true');
            isValid = false;
        }

        // Validate support category
        let supportCategorySelected = false;
        for (let radio of supportCategoryRadios) {
            if (radio.checked) {
                supportCategorySelected = true;
                break;
            }
        }

        if (!supportCategorySelected) {
            categoryError.textContent = "Please select a support category.";
            supportCategoryRadios[0].setAttribute('aria-invalid', 'true');
            isValid = false;
        } else {
            supportCategoryRadios[0].removeAttribute('aria-invalid');
        }

        // Focus on first error
        if (!isValid) {
            if (countrySelect.value === "") {
                countrySelect.focus();
            } else {
                supportCategoryRadios[0].focus();
            }
        }

        return isValid;
    }

    function updateRequiredFields() {
        let selectedCategory = '';
        for (let radio of supportCategoryRadios) {
            if (radio.checked) {
                selectedCategory = radio.value;
                break;
            }
        }
        const country = countrySelect.value;
        let categoryDescription = document.getElementById('contact-category-description');

        // Update description based on category
        if (selectedCategory === 'General Inquiries' || selectedCategory === 'Help With My Order' ) {
            if (country === 'United States') {
                categoryDescription.innerHTML = "Hello! Celestron's team of US-based support experts is here to answer your questions. If you are experiencing a problem, please provide as much information as possible, including your full address and contact information and the model name or item number of your Celestron product. Pictures of the product will also be very helpful. We welcome your inquiries and are happy to help!";
            } else {
                categoryDescription.innerHTML = "Hello! Celestron's team of support experts is here to answer your questions. If you are experiencing a problem, please provide as much information as possible, including your full address and contact information and the model name or item number of your Celestron product. Pictures of the product will also be very helpful. We welcome your inquiries and are happy to help!";
            }
        } else if (selectedCategory === 'Celestron Origin Support') {
            categoryDescription.innerHTML = "Hello! This is the place to get expert help with your Celestron Origin Intelligent Home Observatory. Our California-based team is at the ready to answer all your questions. If your Origin happens to be experiencing issues, we ask that you include the unit's serial number and log files along with your ticket. The serial number is on a sticker at the rear of the tube just in front of the rear cell of the telescope and will start with \"HD\". To download and attach the log files, please connect to Origin, go to \"Settings\" and then \"Advanced\" in the app, and then scroll down and select \"Download and Email Logs.\" If you're using an Android device, we also need a second log file, which you can download by tapping \"Email Android Log File.\" Email the files to yourself, and then attach them to the ticket. These files will streamline the process so we can troubleshoot the issue as quickly as possible. Thank you!";
        } else if (selectedCategory === 'Technical Support') {
            if (country === 'United States') {
                categoryDescription.innerHTML = "Hi there! We understand that technical issues can be frustrating, and our team of US-based support experts is here to help. For the quickest service, please attach proof of purchase or, if you don't have your receipt, let us know approximately when your Celestron product was purchased or produced. Please provide us with as much information as possible when describing your issue. You can use the link at the bottom of this form to attach images, logs, supporting documents, or any other files that you think may be helpful. We're here to make sure you get the most out of your Celestron product, and we look forward to working with you to resolve your issue.";
            } else {
                categoryDescription.innerHTML = "Hi there! We understand that technical issues can be frustrating, and our team of support experts is here to help. For the quickest service, please attach proof of purchase or, if you don't have your receipt, let us know approximately when your Celestron product was purchased or produced. Please provide us with as much information as possible when describing your issue. You can use the link at the bottom of this form to attach images, logs, supporting documents, or any other files that you think may be helpful. We're here to make sure you get the most out of your Celestron product, and we look forward to working with you to resolve your issue.";
            }
        } else if (selectedCategory === 'Dealer Inquiries') {
            categoryDescription.innerHTML = "Greetings, Celestron dealers! If you are a current dealer experiencing an issue with one of our products, please include the product number, purchase order number, and complete contact information in your message below.<br><br>If you want to become a Celestron dealer, please fill out the contact form at:<br> <a href='https://www.celestron.com/pages/contact-us' target='_blank' rel='noopener noreferrer'>https://www.celestron.com/pages/contact-us</a><br><br>If you are a customer looking for an authorized dealer, our self-service dealer locators can help. To find a US or Canadian dealer, visit <a href='https://www.celestron.com/pages/celestron-dealers' target='_blank' rel='noopener noreferrer'>https://www.celestron.com/pages/celestron-dealers</a>. To find an international dealer, visit <a href='https://www.celestron.com/pages/find-a-local-dealer' target='_blank' rel='noopener noreferrer'>https://www.celestron.com/pages/find-a-local-dealer</a>.";
        } else if (selectedCategory === 'Spare Parts') {
            categoryDescription.innerHTML = "Hello! If you need spare parts for your Celestron product, we're here to help. Please provide us with as much relevant information as possible, including images of the part you need or where it attaches to your product. For the quickest service, attach your proof of purchase and any other necessary documents using the link at the bottom of this form. If you don't have a receipt, please let us know approximately when you purchased the product or believe it was made. We'll also need your full shipping address and best contact information to ensure a smooth delivery.";
        }

        // Show/hide conditional fields
        originSupport.classList.add('hidden');
        originSupport.setAttribute('aria-hidden', 'true');
        generalTechnical.classList.add('hidden');
        generalTechnical.setAttribute('aria-hidden', 'true');

        const serialNumberInput = document.getElementById('serialNumber');

        if (selectedCategory === 'Celestron Origin Support') {
            originSupport.classList.remove('hidden');
            originSupport.removeAttribute('aria-hidden');
            serialNumberInput.required = true;
            serialNumberInput.setAttribute('aria-required', 'true');
        } else {
            serialNumberInput.required = false;
            serialNumberInput.removeAttribute('aria-required');
            serialNumberInput.value = '';
        }

        if (selectedCategory === 'General Inquiries' || selectedCategory === 'Technical Support') {
            generalTechnical.classList.remove('hidden');
            generalTechnical.removeAttribute('aria-hidden');
        }
    }

    // Form submission
    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        // Validate file size
        const fileInput = document.getElementById('attachment');
        if (fileInput.files.length > 0) {
            const fileSize = fileInput.files[0].size;
            const maxSize = 10 * 1024 * 1024; // 10MB in bytes
            
            if (fileSize > maxSize) {
                statusElement.textContent = 'Error: File size must be less than 10MB.';
                statusElement.className = 'error';
                fileInput.focus();
                return;
            }
        }

        const formData = new FormData(form);
        statusElement.textContent = 'Sending your ticket...';
        statusElement.className = '';
        
        // Disable submit button
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending...';

        try {
            const response = await fetch('https://celestron-support-contact-f9a2d4afec91.herokuapp.com/', {
                method: 'POST',
                body: formData
            });

            const text = await response.text();
            let result = null;

            try {
                result = text ? JSON.parse(text) : null;
            } catch (parseError) {
                // Server returned non-JSON (e.g. HTML error/warning page) but request may have succeeded
                if (response.ok) {
                    result = { status: 'success' };
                } else {
                    console.warn('API returned non-JSON response:', parseError);
                    result = { status: 'error', message: 'The server returned an unexpected response. Please try again or contact support directly.' };
                }
            }

            if (result && result.status === 'success') {
                statusElement.textContent = "Your message has been sent to Celestron support. We will be in touch with you soon.";
                statusElement.className = 'success';
                form.reset();
                messageCounter.textContent = '0 / 8000 characters';
                step2.classList.add('hidden');
                step2.setAttribute('aria-hidden', 'true');
                step1.classList.remove('hidden');
                step1.removeAttribute('aria-hidden');
                
                // Scroll to status message
                statusElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                statusElement.focus();
            } else {
                let errorMessage = result ? `Error: ${result.message || 'Unknown error'}` : 'An error occurred. Please try again later.';
                if (result && result.details) {
                    errorMessage += `\nDetails: ${result.details}`;
                }
                if (result && result.phpErrors) {
                    errorMessage += `\nPHP Errors: ${result.phpErrors}`;
                }
                statusElement.textContent = errorMessage;
                statusElement.className = 'error';
                statusElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
        } catch (error) {
            console.error('Error:', error);
            statusElement.textContent = 'An error occurred. Please try again later or contact support directly.';
            statusElement.className = 'error';
            statusElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } finally {
            // Re-enable submit button
            submitBtn.disabled = false;
            submitBtn.textContent = 'Send Ticket';
        }
    });

    function validateForm() {
        const visibleRequiredFields = Array.from(
            form.querySelectorAll('input[required]:not([type="hidden"]), select[required], textarea[required]')
        ).filter(field => {
            const container = field.closest('.hidden, [aria-hidden="true"]');
            return !container;
        });

        let isValid = true;
        let firstInvalidField = null;

        for (let field of visibleRequiredFields) {
            if (!field.value.trim()) {
                field.setAttribute('aria-invalid', 'true');
                isValid = false;
                if (!firstInvalidField) {
                    firstInvalidField = field;
                }
            } else {
                field.removeAttribute('aria-invalid');
            }
        }

        if (!isValid) {
            announceToScreenReader('Please fill out all required fields.');
            if (firstInvalidField) {
                firstInvalidField.focus();
                firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }

        return isValid;
    }

    function clearFieldError(field, errorId) {
        const errorElement = document.getElementById(errorId);
        if (errorElement) {
            errorElement.textContent = '';
        }
        field.removeAttribute('aria-invalid');
    }

    function announceToScreenReader(message) {
        const announcement = document.createElement('div');
        announcement.setAttribute('role', 'status');
        announcement.setAttribute('aria-live', 'polite');
        announcement.className = 'sr-only';
        announcement.textContent = message;
        document.body.appendChild(announcement);
        setTimeout(() => {
            document.body.removeChild(announcement);
        }, 1000);
    }

    // Add visual class for screen reader only content
    const style = document.createElement('style');
    style.textContent = `
        .sr-only {
            position: absolute;
            width: 1px;
            height: 1px;
            padding: 0;
            margin: -1px;
            overflow: hidden;
            clip: rect(0, 0, 0, 0);
            white-space: nowrap;
            border-width: 0;
        }
    `;
    document.head.appendChild(style);
});